import type { BuilderUIProviderProps } from "@circle-react-shared/BuilderUI/Store/types";
import "@circle-react-shared/BuilderUI/styles/builder-ui.css";
import { BeforeNavigatingAway } from "./BeforeNavigatingAway";
import { AddButton } from "./Buttons/AddButton";
import { BackButton } from "./Buttons/BackButton";
import { BlocksButton } from "./Buttons/BlocksButton";
import { EditButton } from "./Buttons/EditButton";
import { LayersButton } from "./Buttons/LayersButton";
import { RevisionsButton } from "./Buttons/RevisionsButton";
import { SaveButton } from "./Buttons/SaveButton";
import { SettingsButton } from "./Buttons/SettingsButton";
import { ThemeConfigurationButton } from "./Buttons/ThemeConfigurationButton";
import { UndoRedoButtons } from "./Buttons/UndoRedoButtons";
import { Canvas } from "./Canvas";
import { CanvasCard } from "./Canvas/CanvasCard";
import { FullscreenButton } from "./Canvas/CanvasFullscreenButton";
import { CanvasSize } from "./Canvas/CanvasSize";
import { CanvasZoomableSize } from "./Canvas/CanvasZoomableSize";
import { CanvasControls } from "./CanvasControls";
import { CanvasAppearanceToggle } from "./CanvasControls/CanvasAppearanceToggle";
import { CanvasSizeToggle } from "./CanvasControls/CanvasSizeToggle";
import { CanvasZoomStepper } from "./CanvasControls/CanvasZoomStepper";
import { BlockActions } from "./CanvasTools/BlockActions";
import { CanvasBlockName } from "./CanvasTools/CanvasBlockName";
import { CanvasTools } from "./CanvasTools/CanvasTools";
import { CanvasToolsBlockActions } from "./CanvasTools/CanvasToolsBlockActions";
import { NonIframeCanvasTools } from "./CanvasTools/NonIframeCanvasTools";
import { CollapsibleRightSidebar } from "./CollapsibleRightSidebar";
import { defaultBlocks } from "./DefaultBlocks";
import { Editor } from "./Editor/Editor";
import { FloatingDropZones } from "./FloatingDropZone/FloatingDropZones";
import { StyledFrame } from "./Frames/StyledFrame";
import { TailwindFrame } from "./Frames/TailwindFrame";
import { TailwindFrameWithBottomPadding } from "./Frames/TailwindFrameWithBottomPadding";
import { Header } from "./Header/Header";
import { HeaderDivider } from "./Header/HeaderDivider";
import { useBuilderStore, useSelectedBlock } from "./Hooks/useBuilderStore";
import { ActionButtons } from "./LeftSidebar/ActionButtons";
import { ActionView } from "./LeftSidebar/ActionView";
import { ExpandableLeftSidebar } from "./LeftSidebar/ExpandableLeftSidebar";
import { FixedLeftSidebar } from "./LeftSidebar/FixedLeftSidebar";
import { Main } from "./Main/Main";
import { FullscreenPreview } from "./Preview/FullscreenPreview";
import { StorePreview } from "./Preview/StorePreview";
import { Provider } from "./Provider";
import { RightSidebar } from "./RightSidebar/RightSidebar";
import { Shell } from "./Shell/Shell";
import { SidebarActions } from "./Sidebar/SidebarActions";
import { SidebarHeader } from "./Sidebar/SidebarHeader";
import { SidebarHeaderTitle } from "./Sidebar/SidebarHeaderTitle";
import { SidebarSubTitle } from "./Sidebar/SidebarSubTitle";
import { ThemeManager } from "./ThemeManager/ThemeManager";

export const BuilderUI = Object.assign(
  {},
  {
    ActionButtons,
    ActionView,
    AddButton,
    BackButton,
    BlockActions,
    BlocksButton,
    Canvas,
    CanvasAppearanceToggle,
    CanvasBlockName,
    CanvasCard,
    CanvasControls,
    CanvasSize,
    CanvasSizeToggle,
    CanvasTools,
    CanvasToolsBlockActions,
    CanvasZoomableSize,
    CanvasZoomStepper,
    CollapsibleRightSidebar,
    EditButton,
    Editor,
    ExpandableLeftSidebar,
    FixedLeftSidebar,
    FullscreenButton,
    FullscreenPreview,
    Header,
    HeaderDivider,
    Main,
    NonIframeCanvasTools,
    Provider,
    RevisionsButton,
    RightSidebar,
    SaveButton,
    SettingsButton,
    LayersButton,
    BeforeNavigatingAway,
    Shell,
    SidebarActions,
    SidebarHeader,
    SidebarHeaderTitle,
    SidebarSubTitle,
    StorePreview,
    StyledFrame,
    TailwindFrame,
    ThemeConfigurationButton,
    UndoRedoButtons,
    ThemeManager,
    FloatingDropZones,
    TailwindFrameWithBottomPadding,
  },
);

// eslint-disable-next-line no-barrel-files/no-barrel-files -- Part of the BuilderUI API
export { useBuilderStore, useSelectedBlock, defaultBlocks };

// eslint-disable-next-line no-barrel-files/no-barrel-files -- Part of the BuilderUI API
export { ImagePicker } from "./Editor/fields/ImagePicker";

export type BuilderUIProps = BuilderUIProviderProps;
